import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { DataService } from '@Core/services/proprietary/data.service';
import { Datasource, DataSourceStatus } from '@Core/services/proprietary/datasource';
import { AddTeamMember } from './team-member.actions';

@Injectable()
export class TeamSetService {
    private dsDBQuery: Datasource;
    private dsDBQuerySub: Subscription;

    constructor(private store: Store, private ds: DataService) { }

    initializeService() {
        this.dsDBQuery = this.ds.addNewDatasource('DBQuery');
    }

    endservice() {
        if (this.dsDBQuerySub) {
            this.dsDBQuerySub.unsubscribe();
        }
        if (this.dsDBQuery) {
            this.ds.deleteDatasource(this.dsDBQuery);
        }
    }

    getDefaultTeamSet(teamSetID: any) {
        let criteria: any = {
            Procedure_Name: 'epx_getteam',
            Book_Entity_ID: 'CURRENTUSER',
            Team_Set_ID: teamSetID,
            View: 'Full'
        };

        this.dsDBQuerySub = this.dsDBQuery.status$.subscribe((status) => {
            this.getDefaultTeamSetSub(status);
        });

        this.dsDBQuery.getCollection(criteria, true, true);
    }

    getDefaultTeamSetSub(status: DataSourceStatus) {
        switch (status) {
            case DataSourceStatus.Ready:
                if (this.dsDBQuerySub) {
                    this.dsDBQuerySub.unsubscribe();
                }
                if (this.dsDBQuery && this.dsDBQuery.objectNodes.length == 1) {
                    let teamMembers = this.dsDBQuery.objectNodes[0].Team_Members.Team_Member;

                    for (var i in teamMembers) {
                        this.store.dispatch(new AddTeamMember(teamMembers[i]));
                    }

                    this.endservice();
                }
                break;
            case DataSourceStatus.Error:
                if (this.dsDBQuerySub) {
                    this.dsDBQuerySub.unsubscribe();
                }
                this.endservice();
                break;
        }
    }
}
